import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Footer.css';

const handleAnchorClick = (e, href) => {
  if (href.startsWith('/#')) {
    e.preventDefault();
    const id = href.slice(2);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
};

export default function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__top-divider" />
      <div className="container">
        <div className="footer__grid">
          {/* Brand column */}
          <div className="footer__brand">
            <img src={logo} alt="TaxiOps" className="footer__logo" />
            <p className="footer__tagline">
              Classic Dispatch. Modern Operations.<br />AI-Powered Intelligence.
            </p>
            <div className="footer__badges">
              <span className="badge badge--gray">Taxi &amp; NEMT Platform</span>
              <span className="badge badge--gray">An Old Alex Hub Company</span>
            </div>
            <p className="footer__phase-note">
              Focused implementation period active.<br />
              Open self-service enrollments are not available.
            </p>
            <div className="footer__store-badges">
              <a
                href="https://play.google.com/store/apps/details?id=com.oldalexhub.taxiops.driver"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__store-badge"
                aria-label="Get TaxiOps Driver on Google Play"
              >
                <svg className="footer__store-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M4.2 3.1c-.4.25-.7.78-.7 1.48v14.84c0 .7.3 1.23.7 1.48l8.58-8.9L4.2 3.1z" fill="#34d399"/>
                  <path d="M13.78 10.96 16.2 8.45 5.72 2.57c-.48-.27-.92-.3-1.27-.12l9.33 8.51z" fill="#60a5fa"/>
                  <path d="M13.78 13.04 4.45 21.55c.35.18.79.15 1.27-.12l10.48-5.88-2.42-2.51z" fill="#fbbf24"/>
                  <path d="m16.2 8.45-2.42 2.51L12.78 12l1 1.04 2.42 2.51 2.64-1.48c1.07-.6 1.07-1.54 0-2.14L16.2 8.45z" fill="#ef4444"/>
                </svg>
                <span className="footer__store-text">
                  <span className="footer__store-label">Get it on</span>
                  <span className="footer__store-name">Google Play</span>
                </span>
              </a>
              <a
                href="https://apps.apple.com/us/app/taxiops-driver/id6775650748"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__store-badge"
                aria-label="Download TaxiOps Driver on the App Store"
              >
                <svg className="footer__store-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98l-.09.06c-.22.14-2.18 1.27-2.16 3.8.03 3.02 2.65 4.03 2.68 4.04l-.07.28zM13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                <span className="footer__store-text">
                  <span className="footer__store-label">Download on the</span>
                  <span className="footer__store-name">App Store</span>
                </span>
              </a>
            </div>
          </div>

          {/* Platform links */}
          <div className="footer__col">
            <h4 className="footer__col-title">Platform</h4>
            <ul className="footer__col-links" >
              <li><a href="/#platform" onClick={(e) => handleAnchorClick(e, '/#platform')}>Platform Overview</a></li>
              <li><a href="/#ai" onClick={(e) => handleAnchorClick(e, '/#ai')}>Operations Intelligence</a></li>
              <li><a href="/#platform" onClick={(e) => handleAnchorClick(e, '/#platform')}>Driver Onboarding</a></li>
              <li><a href="/#platform" onClick={(e) => handleAnchorClick(e, '/#platform')}>Dispatch Operations</a></li>
              <li><a href="/#platform" onClick={(e) => handleAnchorClick(e, '/#platform')}>Live Fleet Mapping</a></li>
              <li><a href="/#platform" onClick={(e) => handleAnchorClick(e, '/#platform')}>Receipts &amp; Reporting</a></li>
            </ul>
          </div>

          {/* Company links */}
          <div className="footer__col">
            <h4 className="footer__col-title">Company</h4>
            <ul className="footer__col-links" >
              <li><a href="/#about" onClick={(e) => handleAnchorClick(e, '/#about')}>Old Alex Hub</a></li>
              <li><a href="/#launch" onClick={(e) => handleAnchorClick(e, '/#launch')}>Phase One Launch</a></li>
              <li><a href="/#contact" onClick={(e) => handleAnchorClick(e, '/#contact')}>Contact</a></li>
              <li>
                <a href="mailto:info@oldalexhub.com" className="footer__email">
                  info@oldalexhub.com
                </a>
              </li>
            </ul>
          </div>

          {/* Contact column */}
          <div className="footer__col">
            <h4 className="footer__col-title">Inquiries</h4>
            <ul className="footer__col-links" >
              <li>
                <a href="mailto:info@oldalexhub.com?subject=TaxiOps Future Availability Inquiry">
                  Future Availability
                </a>
              </li>
              <li>
                <a href="mailto:info@oldalexhub.com?subject=TaxiOps Strategic Partnership Inquiry">
                  Strategic Partnership
                </a>
              </li>
              <li>
                <a href="mailto:info@oldalexhub.com?subject=TaxiOps General Information Request">
                  General Information
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            &copy; {new Date().getFullYear()} Old Alex Hub. TaxiOps is an official business venture of Old Alex Hub. All rights reserved.
          </p>
          <div className="footer__legal-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="footer__legal-sep" aria-hidden="true">·</span>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
